(function () {
  function initBannerCarousel(root) {
    if (root.dataset.bannerCarouselInit === 'true') return;
    root.dataset.bannerCarouselInit = 'true';

    var viewport = root.querySelector('[data-banner-carousel-viewport]');
    var track = root.querySelector('[data-banner-carousel-track]');
    var prevBtn = root.querySelector('[data-banner-carousel-prev]');
    var nextBtn = root.querySelector('[data-banner-carousel-next]');
    var navWrap = root.querySelector('[data-banner-carousel-nav]');

    if (!viewport || !track) return;

    var mobileSlider = root.dataset.mobileSlider === 'true';
    var desktopCount = parseInt(root.dataset.desktopCount, 10) || 2;
    var autoplayDelay = parseInt(root.dataset.autoplayDelay, 10) || 5000;
    var index = 0;
    var desktopQuery = window.matchMedia('(min-width: 1024px)');
    var autoplayTimer = null;
    var resizeRaf = null;
    var viewportObserver = null;

    function isDesktop() {
      return desktopQuery.matches;
    }

    function getSlidesPerView() {
      return isDesktop() ? desktopCount : 1;
    }

    function getSlideCount() {
      return track.children.length;
    }

    function getGap() {
      return parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
    }

    function getSlideWidth() {
      var slide = track.children[0];
      return slide ? slide.getBoundingClientRect().width : 0;
    }

    function getStepSize() {
      return getSlideWidth() + getGap();
    }

    function getMaxScrollOffset() {
      var slideCount = getSlideCount();
      if (!slideCount) return 0;
      var slideWidth = getSlideWidth();
      var gap = getGap();
      var viewportWidth = viewport.getBoundingClientRect().width;
      var totalWidth = slideCount * slideWidth + (slideCount - 1) * gap;
      return Math.max(0, totalWidth - viewportWidth);
    }

    function getMaxIndex() {
      if (isDesktop()) {
        var slides = getSlideCount();
        var perView = getSlidesPerView();
        return Math.max(0, Math.ceil(slides - perView));
      }

      var step = getStepSize();
      if (!step) return 0;
      return Math.max(0, Math.round(getMaxScrollOffset() / step));
    }

    function shouldUseSlider() {
      if (isDesktop()) return true;
      return mobileSlider;
    }

    function isAutoplayOn() {
      return isDesktop()
        ? root.dataset.desktopAutoplay === 'true'
        : root.dataset.mobileAutoplay === 'true';
    }

    function updateNavVisibility() {
      if (!navWrap) return;
      var showMobile = navWrap.dataset.showMobile === 'true';
      var showDesktop = navWrap.dataset.showDesktop === 'true';
      var visible = isDesktop() ? showDesktop : showMobile;
      navWrap.classList.toggle('is-visible', visible && shouldUseSlider());
    }

    function updateCarousel() {
      var slides = getSlideCount();
      if (!slides) return;

      updateNavVisibility();

      if (!shouldUseSlider()) {
        track.style.transform = '';
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        return;
      }

      index = Math.max(0, Math.min(getMaxIndex(), index));
      var offset = Math.min(index * getStepSize(), getMaxScrollOffset());
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = offset >= getMaxScrollOffset() - 1 || index >= getMaxIndex();
    }

    function resetAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      autoplayTimer = null;
      if (!isAutoplayOn() || !shouldUseSlider()) return;

      autoplayTimer = setInterval(function () {
        index = index >= getMaxIndex() ? 0 : index + 1;
        updateCarousel();
      }, autoplayDelay);
    }

    function goTo(direction) {
      if (!shouldUseSlider()) return;
      index = Math.max(0, Math.min(getMaxIndex(), index + direction));
      updateCarousel();
      resetAutoplay();
    }

    function handleResize() {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        if (!isDesktop()) {
          index = 0;
        } else {
          index = Math.min(index, getMaxIndex());
        }
        updateCarousel();
        resetAutoplay();
      });
    }

    function observeViewport() {
      if (viewportObserver) viewportObserver.disconnect();
      if (typeof ResizeObserver === 'undefined') return;

      viewportObserver = new ResizeObserver(handleResize);
      viewportObserver.observe(viewport);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(1);
      });
    }

    var touchStartX = 0;
    var touchDeltaX = 0;

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!shouldUseSlider()) return;
        touchStartX = e.changedTouches[0].screenX;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (e) {
        if (!shouldUseSlider()) return;
        touchDeltaX = e.changedTouches[0].screenX - touchStartX;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        if (!shouldUseSlider() || Math.abs(touchDeltaX) < 40) return;
        goTo(touchDeltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );

    window.addEventListener('resize', handleResize, { passive: true });

    desktopQuery.addEventListener('change', function () {
      index = isDesktop() ? Math.min(index, getMaxIndex()) : 0;
      updateCarousel();
      resetAutoplay();
    });

    observeViewport();
    requestAnimationFrame(function () {
      updateCarousel();
      resetAutoplay();
    });
  }

  function bootBannerCarousels(scope) {
    requestAnimationFrame(function () {
      var roots = (scope || document).querySelectorAll('[data-banner-carousel]:not([data-banner-carousel-init="true"])');
      for (var i = 0; i < roots.length; i++) {
        initBannerCarousel(roots[i]);
      }
    });
  }

  function onReady() {
    bootBannerCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootBannerCarousels(event.target);
  });
})();
